import { useTranslation } from "react-i18next";

const ConceptRainbow = () => {
  const { t } = useTranslation();
  return (
    <div className="main__content" id="main__content__v2">
      <div className="item3">
        <div className=" text__content">
          <p id="concept__rainbow_title_t1">{t("concept__rainbow_title_1")}</p>
          <span id="concept__rainbow_title_t2">
            {t("concept__rainbow_title_2")}
          </span>
          <span className="rainbow__text_t1" id="concept__rainbow_title_t3">
            {t("concept__rainbow_title_3")}
          </span>
        </div>
        <div id="gradient__photo">
          <img id="img_gradient__photo" src="/assets/images/Concept1.svg" />
        </div>
      </div>
    </div>
  );
};
export default ConceptRainbow;
